import * as React from 'react';
import { Alert, GlobalStyles, Tooltip } from "@mui/material";
import tooltipClasses from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import AlertDialog2 from '../../components/AlertDialog2';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import { styled } from '@mui/material/styles';
import { AuthUserContext } from "../../providers/AuthProvider";
import { useNavigate } from 'react-router-dom';
import firebase from "../../firebase/firebase"
import { HelpOutlineOutlined} from '@mui/icons-material';
import {
  Container,
  Typography,
  Stack,
  Grid,
  Button,
} from "@mui/material";
import AlertDialog from '../../components/AlertDialog';
import Spinner from '../../components/spinner';
import PostActivity from "../../helpers/post-activity";


const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "300px",
    backgroundColor: "#204488",
  },
});


export default function PasswordSettings() {
  const [loading , setLoading] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const { user, profile, setProfile, setUser } = React.useContext(AuthUserContext);
  const navigator = useNavigate();
  const [values, setValues] = React.useState({
    oldpassword: '',
    newpassword: '',
    confirmpassword: '',
    showoldPassword: false,
    shownewPassword: false,
    showconfirmPassword: false,
  });

  const [newPasswordError,setNewPasswordError] = React.useState("");
  const [confirmPasswordError,setConfirmPasswordError] = React.useState("");
  const [updateStatus, setUpdateStatus] = React.useState("")
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showoldPassword: !values.showoldPassword,
     
    });
  };

  const handleClickNewShowPassword = () => {
    setValues({
      ...values,
      shownewPassword: !values.shownewPassword,
    });
  };

  const handleClickConfirmShowPassword = () => {
    setValues({
      ...values,
      showconfirmPassword: !values.showconfirmPassword,
    });
  };


  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const reauthenticate = (oldpassword) => {
      const cred = firebase.auth.EmailAuthProvider.credential(
          user.email, oldpassword);
      return user.reauthenticateWithCredential(cred);
    };
  
  const handleSubmit = async (e) =>{
    setLoading(true)
    e.preventDefault();
    setUpdateStatus("")
    try{
      if(!newPasswordError && !confirmPasswordError){
        reauthenticate(values.oldpassword).then(()=>{
          user.updatePassword(values.newpassword).then(()=>{
            setLoading(false);
            setOpen(true);
             PostActivity({
              text: 'You successfully updated your password.',
              uid: profile.uid,
              createdBy:profile?.uid
            }).then()
          }).catch((error)=>{setUpdateStatus("There was a problem in updating your password. Please Try again"); setLoading(false)})
        }).catch((error)=>{setUpdateStatus("The old password you have entered is invalid or there was a problem in reauthentication"); setLoading(false)})
        
      }

    }catch(e){
       setLoading(false)
       setUpdateStatus(e)
    }
  };

  const handleValidation = (event) => {
      event.preventDefault();
      const value= event.target.value.trim();
      const passwordInputFieldName = event.target.name;
      
      // for new password
    
  if(passwordInputFieldName === 'newpassword'){
      const uppercaseRegExp = /(?=.*?[A-Z])/;
      const lowercaseRegExp = /(?=.*?[a-z])/;
      const digitsRegExp = /(?=.*?[0-9])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
      const minLengthRegExp   = /.{8,}/;

      const passwordLength =      value.length;
      const uppercasePassword =   uppercaseRegExp.test(value);
      const lowercasePassword =   lowercaseRegExp.test(value);
      const digitsPassword    = digitsRegExp.test(value);
      const specialCharPassword = specialCharRegExp.test(value);
      const minLengthPassword =   minLengthRegExp.test(value);

      
      if(passwordLength===0)
      {setNewPasswordError("Your Password is empty.")}
      else if(!uppercasePassword)
      {setNewPasswordError("Your password must have at least one uppercase.")}
      else if(!lowercasePassword)
      {setNewPasswordError("Your password must have at least one lowercase.")}
      else if(!digitsPassword)
      {setNewPasswordError("Your password must have at least one number.")}
      else if(!specialCharPassword)
      {setNewPasswordError("Your password must have at least one special character.")}
      else if(!minLengthPassword)
      {setNewPasswordError("Your password must have at least 8 characters.")}
      else{
        setNewPasswordError("");
        // sethasError(false);
      }   
      
    }

    // Confirm Password
    
    if(passwordInputFieldName=== "confirmpassword" || (passwordInputFieldName==="newpassword" && values.confirmpassword.length>0)){

      if(values.confirmpassword!==values.newpassword)
      { setConfirmPasswordError("Please make sure your passwords match.")
        }
      else{
        setConfirmPasswordError("");
      }
    }
  }
  if (loading) return <Spinner/>;
  return ( 
   <>
    <GlobalStyles
      styles={{ ul: { margin: 0, padding: 0, listStyle: "none" } }}
      />
    {open && <AlertDialog open={true} title={`Success`} message={`Your password has been reset succesfully.`} btn_Orange_Text={`OK`} btn_function={
        ()=> navigator(`/${profile?.userType === 'artist' ? 'artists'  : profile?.userType}/settings`)
    }/>}

    <Container maxWidth="lg" component="main" sx={{}}>
        <Box sx={{pt: 7, pl: 2 }}>
          <Typography
            align="left"
            variant="h4"
            color="text.primary"
            fontWeight="600"
            component="p"
          >
            Profile
          </Typography>
          <br />
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              variant="body"
              color="text.primary"
              fontSize="24px"
              fontWeight="600"
              component="p"
              sx={{ margin: "30px 0px" }}
            >
              Change your password
            </Typography>
            </Stack>
            {updateStatus && <Alert severity='error'>{updateStatus}</Alert>}
              <Box
                onSubmit={handleSubmit}
                component="form"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: 2,
                  mt: 6,
                  flexDirection: "column",
                }}
              >

              <Grid container spacing={2}>
              <Grid item xs={11}>              
                    <FormControl sx={{ width: '100%'}} variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">Old Password</InputLabel>
                      <OutlinedInput
                        type={values.showoldPassword ? 'text' : 'password'}
                        value={values.oldpassword}
                        required
                        onChange={handleChange('oldpassword')
                      }
                      
                      endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                              >
                              {!values.showoldPassword ? <img src="/assets/eye_close.png" alt=""/> : <img src="/assets/eye_open.png" alt=""/>}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="oldpassword"
                        />
                        <Typography align='left' sx={{color:"#ED1C24", fontWeight:"500", fontSize:"16px"}}>&nbsp;</Typography>
                    </FormControl>
              </Grid>

              <Grid item xs={11}>              
                    <FormControl sx={{ width: '100%'}} variant="outlined" >
                      <InputLabel htmlFor="outlined-adornment-password" sx={{display:"flex", flexDirection:"row"}}>New Password
                      <Tooltip 
                      componentsProps={{
                        tooltip: {
                          sx: {
                            maxWidth: "150px",
                            bgcolor: '#204488',
                            '& .MuiTooltip-arrow': {
                              color: '#204488',
                            },
                          },
                        },
                      }}
                      title={<>Password must have : <br/> 1 Uppercase <br/>1 Lowercase <br/>1 Number <br/>1 Special character <br/>8 Characters </>} arrow sx={{width:"100px"}} placement="top-start">
                          <HelpOutlineOutlined sx={{borderRadius:"100%", ml:1, fontSize:"24px", backgroundColor:"#FFFFFF"}}/>
                        </Tooltip>
                      </InputLabel>
                      <OutlinedInput
                        required
                        error={newPasswordError}
                        type={values.shownewPassword ? 'text' : 'password'}
                        value={values.newpassword}
                        onChange={handleChange('newpassword')}
                        onKeyUp={handleValidation}
                        name="newpassword"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickNewShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                              >
                              {!values.shownewPassword ? <img src="/assets/eye_close.png" alt=""/> : <img src="/assets/eye_open.png" alt=""/>}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="newpassword"
                       
                        />
                         <Typography align='left' sx={{color:"#ED1C24", fontWeight:"500", fontSize:"16px"}}>{newPasswordError}&nbsp;</Typography>
                    </FormControl>
              </Grid>

              <Grid item xs={11}>              
                    <FormControl sx={{width: '100%' }} variant="outlined">
                      <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
                      <OutlinedInput
                        required
                        error={confirmPasswordError}
                        type={values.showconfirmPassword ? 'text' : 'password'}
                        value={values.confirmpassword}
                        onKeyUp={handleValidation}
                        onChange={handleChange('confirmpassword')}
                        name="confirmpassword"
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleClickConfirmShowPassword}
                              onMouseDown={handleMouseDownPassword}
                              edge="end"
                              >
                              {!values.showconfirmPassword ? <img src="/assets/eye_close.png" alt=""/> : <img src="/assets/eye_open.png" alt=""/>}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="confirmpassword"
                        />
                        <Typography align='left' sx={{color:"#ED1C24", fontWeight:"500", fontSize:"16px"}}>{confirmPasswordError}&nbsp;</Typography>
                    </FormControl>
              
            </Grid>
                <Grid item xs={10}>
                    <Grid
                         container
                         direction="row"
                         justifyContent="center"
                         alignItems="center"
                         >
                        <Grid item xs={4}>
                            <Button 
                            sx={{width:238, height:43, textDecoration:"underline"}}
                            fontSize="16px" fontWeight="400"
                            color="primary"
                            onClick={(e)=> navigator(-1)}
                            >
                               Quit Without Saving
                            </Button>
                        </Grid>
                        <Grid item xs={4}>
                        <Button
                        type={'submit'}
                            sx={{width: 170, height:43, fontSize: 16, fontWeight:400, backgroundColor:'#FD4A01', textTransform:"none" }} disabled={newPasswordError || confirmPasswordError || values.oldpassword.length===0 || values.confirmpassword.length===0} variant={'contained'} color={'warning'}
                            
                            >Save Changes</Button>
                        </Grid>      
                    </Grid>
                  </Grid>              

        </Grid>
 
     </Box>
    </Box>
 
 
      </Container>
    </>
  );
}
